import { Dispatch } from 'redux';
import { AxiosError, AxiosResponse } from 'axios';
import { UNHANDLED_EXCEPTION, SET_EXCEPTION_HANDLER, RESET_STATE, RESET_EXCEPTION, SHELL_CONFIG, SHELL_CONFIG_LOADING, LOADING_DATA, RESET_SCROLL, GRID_CHECK_ALL } from '@app/store/constants';
import { basicService, authService, vaultsService } from '@app/services';
import { currentUser } from '@app/store/actions';
import { localStore } from '@app/helpers';

// This should only be done in the app component
export function handleShellConfig(callback?: Function) {
    return ((dispatch: Dispatch) => {
        const isSignedIn = authService.isSignedIn();
        if (!isSignedIn) {
            const emptyShell = { authActive: false };
            dispatch(getShellConfig(emptyShell));
            basicService.setShellConfig(JSON.stringify(emptyShell));
            return
        }

        dispatch(shellConfigLoading(true));
        basicService.getShellConfig().then(async (response: AxiosResponse) => {
            const shellData = response.data;
            dispatch(getShellConfig(shellData));
            basicService.setShellConfig(JSON.stringify(shellData));
            const { data } = await vaultsService.getVaultsPermissions();
            shellData.claims.vaults = data.vaults;
            authService.setUserDataFromShell(shellData.claims);
            dispatch(shellConfigLoading(false));

            if (callback) {
                callback();
            }
        }).catch((err: AxiosError) => {
            if (err.response?.status == 401) {
                const emptyShell = { authActive: false };
                dispatch(getShellConfig(emptyShell));
                basicService.setShellConfig(JSON.stringify(emptyShell));
            }
            dispatch(shellConfigLoading(false));
        });
    });
}

// If some action you've completed requires a reload of the shell, use this
export function handleReloadShellConfig() {
    return ((dispatch: Dispatch) => {
        basicService.getShellConfig().then(async (response: AxiosResponse) => {
            const shellData = response.data;
            const isSignedIn = authService.isSignedIn();
            dispatch(getShellConfig(shellData));
            basicService.setShellConfig(JSON.stringify(shellData));
            if (isSignedIn) {
                const { data } = await vaultsService.getVaultsPermissions();
                shellData.claims.vaults = data.vaults;
            }
            authService.setUserDataFromShell(shellData.claims);
        });
    });
}

export function shellConfigLoading(loading: boolean) {
    return {
        payload: loading,
        type: SHELL_CONFIG_LOADING
    };
}

export function getShellConfig(shell: any) {
    return {
        payload: shell,
        type: SHELL_CONFIG
    };
}

export function loadingData(loading: boolean) {
    return {
        payload: loading,
        type: LOADING_DATA
    };
}

export function resetState() {
    return {
        payload: {},
        type: RESET_STATE
    };
}

export function resetException() {
    return {
        payload: {},
        type: RESET_EXCEPTION
    };
}

export function loadCurrentUser() {
    return ((dispatch: Dispatch) => {
        let storage = localStore;

        if (storage.getItem('ephemeral_session') === 'true') {
            storage = sessionStorage;
        }

        let currUser = storage.getItem('kaseya-user');
        if (currUser !== null) {
            dispatch(currentUser(JSON.parse(currUser)));
        }
    });
}

export function setExceptionHandler(handleExceptions: boolean) {
    return {
        payload: handleExceptions,
        type: SET_EXCEPTION_HANDLER
    };
}

export function unhandledException(unhandledException: any) {
    return {
        payload: unhandledException,
        type: UNHANDLED_EXCEPTION
    };
}

export function resetScroll() {
    return {
        type: RESET_SCROLL
    };
}

export function gridCheckAll(checked: boolean) {
    return {
        payload: checked,
        type: GRID_CHECK_ALL
    };
}
